export default {
  priority: 95,
  name: app.translate('routes.home.attendance.shift.Shift'),
  path: 'shift',
  permissions: ['TimeAttendanceMenu/ShiftMenu'],
  icon: 'calendar-clock',
  drawer: true,
};


